<div 
  [style.--font-size.px]="fontSize"
  (resized)="onElementResized($event)">
  <finexp-ui-loading-rates *ngIf="isLoading"></finexp-ui-loading-rates>
  <div
    *ngIf="!isLoading && rate"
    class="rate-button"
    [class.rate-button-small]="isSmallSize"
    [style.color]="mainTextColor"
    [style.background]="buttonColor">
    <ng-content></ng-content>
  </div>


  <ng-container
    *ngIf="isShowSelectedRateDetails && rate && !isLoading">
    <finexp-ui-selected-rate-details
      [config]="config"
      [forceDefaultStyles]="forceDefaultStyles"
      [details]="rate.details"
      [fontSize]="fontSize"
      *ngIf="rate.details?.length"
    ></finexp-ui-selected-rate-details>
    <finexp-ui-selected-rate-details
      [config]="config"
      [forceDefaultStyles]="forceDefaultStyles"
      [details]="line"
      [fontSize]="fontSize"
      *ngFor="let line of (rate?.detailLines || [])"
    ></finexp-ui-selected-rate-details>
  </ng-container>

  <finexp-ui-rate-error *ngIf="!rate && !error && !isLoading">No rates available</finexp-ui-rate-error>

  <finexp-ui-rate-error *ngIf="error">{{ error }}</finexp-ui-rate-error>
</div>
